import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { Helmet } from "react-helmet";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import WhyChooseUs from "./components/WhyChooseUs";
import Testimonials from "./components/Testimonials";
import DownloadSection from "./components/DownloadSection";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    // Add animation classes after page load
    const elements = document.querySelectorAll('.hero-content, .hero-mockup');
    elements.forEach((el, index) => {
      setTimeout(() => {
        el.style.opacity = '1';
      }, index * 300);
    });
  }, []);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App relative min-h-screen overflow-hidden bg-slate-50 text-slate-900 dark:bg-[#040816] dark:text-slate-100">
          <div aria-hidden="true" className="pointer-events-none absolute inset-0">
            <div className="absolute -left-24 top-32 h-80 w-80 rounded-full bg-cyan-500/10 blur-[120px] dark:bg-cyan-500/12" />
            <div className="absolute right-0 top-[28%] h-[26rem] w-[26rem] rounded-full bg-blue-500/10 blur-[140px] dark:bg-blue-500/12" />
            <div className="absolute left-1/3 bottom-24 h-72 w-72 rounded-full bg-sky-400/8 blur-[120px] dark:bg-sky-400/10" />
          </div>


          <div className="relative z-10">
            {/* SEO Meta Tags */}
            <Helmet>
              <title>Kaamhub - Smart Freelance Marketplace | Connect, Hire, Work, Grow</title>
              <meta
                name="description"
                content="Kaamhub is a smart platform that connects clients with skilled freelancers quickly and efficiently. Discover reliable services, genuine projects, and broker-supported matching for faster hiring."
              />
              
              <meta
                name="keywords"
                content="freelance platform, skilled freelancers, hire freelancers, client freelancer marketplace, broker supported matching, reliable services, genuine projects, Kaamhub"
              />
              <meta name="author" content="Kaamhub" />
              <meta name="viewport" content="width=device-width, initial-scale=1.0" />
              <meta name="robots" content="index, follow" />
              <link rel="canonical" href="https://kaamhub.com" />

              {/* Open Graph Meta Tags */}
              <meta property="og:title" content="Kaamhub - Smart Freelance Marketplace" />
              <meta
                property="og:description"
                content="Smart platform connecting clients with skilled freelancers for faster hiring, genuine projects, and trusted outcomes."
              />
              <meta property="og:type" content="website" />
              <meta property="og:url" content="https://kaamhub.com" />
              <meta
                property="og:image"
                content="https://kaamhub.com/logo.png"
              />
              <meta property="og:site_name" content="Kaamhub" />

              {/* Twitter Card Meta Tags */}
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:title" content="Kaamhub - Smart Freelance Marketplace" />
              <meta
                name="twitter:description"
                content="Smart platform connecting clients with skilled freelancers for faster hiring, genuine projects, and trusted outcomes."
              />
              <meta
                name="twitter:image"
                content="https://kaamhub.com/logo.png"
              />

              {/* Additional SEO */}
              <meta name="theme-color" content="#0ea5e9" />
              <meta name="apple-mobile-web-app-capable" content="yes" />
              <meta name="apple-mobile-web-app-status-bar-style" content="default" />
              <meta name="apple-mobile-web-app-title" content="Kaamhub" />
            </Helmet>

            {/* JSON-LD Structured Data */}
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "WebApplication",
                "name": "Kaamhub",
                "description": "Smart platform connecting clients with skilled freelancers quickly and efficiently with broker-supported matching.",
                "url": "https://kaamhub.com",
                "applicationCategory": "BusinessApplication",
                "operatingSystem": "iOS, Android",
                "offers": {
                  "@type": "Offer",
                  "price": "0",
                  "priceCurrency": "USD"
                },
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.5",
                  "ratingCount": "2000"
                }
              })}
            </script>
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Kaamhub",
                "url": "https://kaamhub.com",
                "email": "Kaamhub.support@gmail.com",
                "telephone": "+91 80082 25407",
                "address": {
                  "@type": "PostalAddress",
                  "addressLocality": "Hyderabad",
                  "addressRegion": "Telangana",
                  "addressCountry": "IN"
                },
                "description": "Smart platform connecting clients with skilled freelancers quickly and efficiently with broker-supported matching."
              })}
            </script>

            <Header />
            <main>
              <Hero />
              <About />
              <Features />
              <HowItWorks />
              <WhyChooseUs />
              <Testimonials />
              <DownloadSection />
              <Contact />
            </main>
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
